import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import "./HomeClients.css";
import { FileUpload } from "primereact/fileupload";

function HomeClients() {
  let emptyHomeClient = {
    id: null,
    alt: "",
    imageUrl: "",
    sortOrder: null,
  };
  const [HomeClients, setHomeClients] = useState(null);

  const [HomeClientsDialog, setHomeClientsDialog] = useState(false);
  const [DeleteHomeClient, setDeleteHomeClient] = useState(false);
  const [DeleteHomeClientsDialog, setDeleteHomeClientsDialog] = useState(false);
  const [HomeClient, setHomeClient] = useState(emptyHomeClient);
  const [selectedHomeClients, setSelectedHomeClients] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const [file, setFile] = useState(null);
  const dt = useRef(null);

  const isFetched = useRef(false);

  useEffect(() => {
    if (!isFetched.current) {
      getHomeClients();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);
  const getHomeClients = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/HomePageClients"
      );

      if (response.data) {
        setHomeClients(response.data);
      }
    } catch (error) {
      console.error("Error fetching Clients:", error);
    }
  };

  const openNew = () => {
    setHomeClient(emptyHomeClient);
    setSubmitted(false);
    setHomeClientsDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setHomeClientsDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteHomeClient(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteHomeClientsDialog(false);
  };

  const saveService = async () => {
    setLoading(true);
    setSubmitted(true);

    try {
      let _HomeClients = [...HomeClients];
      let _HomeClient = { ...HomeClient };

      if (HomeClient.id) {
        const index = findIndexById(HomeClient.id);

        let formData = new FormData();
        formData.append("Id", HomeClient.id);
        formData.append("Alt", _HomeClient.alt);
        formData.append(
          "SortOrder",
          isNaN(parseInt(_HomeClient.sortOrder))
            ? 1
            : parseInt(_HomeClient.sortOrder)
        );

        if (file != null) {
          formData.append("ImageUrl", file);
        }

        const response = await axios.put(
          process.env.REACT_APP_BACKEND_URL +
            "api/HomePageClients/" +
            HomeClient.id,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (response.data.success) {
          _HomeClients[index] = _HomeClient;
          if (response.data.fileName !== "")
            _HomeClients[index].imageUrl = response.data.fileName;
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Client Updated",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Client Not Updated",
            life: 3000,
          });
        }
      } else {
        _HomeClient.id = createId();
        let formData = new FormData();
        formData.append("Alt", _HomeClient.alt);
        formData.append(
          "SortOrder",
          isNaN(parseInt(_HomeClient.sortOrder))
            ? 1
            : parseInt(_HomeClient.sortOrder)
        );
        formData.append("ImageUrl", file);
        const response = await axios.post(
          process.env.REACT_APP_BACKEND_URL + "api/HomePageClients",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );

        if (response.data.success) {
          _HomeClients.push(response.data.client);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Client Added",
            life: 3000,
          });
        } else {
          toast.current.show({
            severity: "error",
            summary: "Error",
            detail: "Client Not Added",
            life: 3000,
          });
        }
      }

      setHomeClients(_HomeClients);
      setHomeClientsDialog(false);
      setHomeClient(emptyHomeClient);
    } catch (error) {
      console.error("Error during save operation:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "An error occurred while saving the client. Please try again later.",
        life: 3000,
      });
    } finally {
      setLoading(false);
      setFile(null);
    }
  };

  const editProduct = (HomeClient) => {
    setHomeClient({ ...HomeClient });
    setHomeClientsDialog(true);
  };

  const confirmDeleteProduct = (HomeClient) => {
    setHomeClient(HomeClient);
    setDeleteHomeClient(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BACKEND_URL +
          "api/HomePageClients/" +
          HomeClient.id
      );

      setLoading(false);

      if (response.data.success) {
        let _HomeClients = HomeClients.filter(
          (val) => val.id !== HomeClient.id
        );
        setHomeClients(_HomeClients);
        setDeleteHomeClient(false);
        setHomeClient(emptyHomeClient);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Client Deleted",
          life: 3000,
        });
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Client Not Deleted",
        life: 3000,
      });
    }
  };

  const onFileUpload = async (event) => {
    setLoading(true);
    const file = event.files[0];

    setFile(file);

    setHomeClient((prevProductImage) => ({
      ...prevProductImage,
      imageUrl: process.env.REACT_APP_BACKEND_URL_IMAGES + file.name, // Save the file name as the image path for simplicity
    }));
    setLoading(false);
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < HomeClients.length; i++) {
      if (HomeClients[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteHomeClientsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedHomeClients.map((HomeClient) => HomeClient.id);
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL + "api/HomePageClients/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _HomeClients = HomeClients.filter(
        (val) => !selectedHomeClients.includes(val)
      );
      setHomeClients(_HomeClients);
      setDeleteHomeClientsDialog(false);
      setSelectedHomeClients(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Clients Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Clients Not Deleted",
        life: 3000,
      });
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _HomeClient = { ...HomeClient };

    _HomeClient[`${name}`] = val;

    setHomeClient(_HomeClient);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Home Clients</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={!selectedHomeClients || !selectedHomeClients.length}
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Product Icons</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        style={{ borderRadius: "10px" }}
        onClick={hideDialog}
      />
      <Button
        label="Save"
        loading={loading}
        style={{ borderRadius: "10px" }}
        icon="pi pi-check"
        onClick={saveService}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );
  const imageBodyTemplate = (rowData) => {
    return (
      <img
        loading="lazy"
        src={process.env.REACT_APP_BACKEND_URL_IMAGES + rowData.imageUrl}
        alt={rowData.imageUrl}
        className="shadow-2 border-round"
        style={{ width: "64px" }}
      />
    );
  };
  return (
    <div className="col-12">
      <div className="HomeClient-container">
        <Toast ref={toast} />
        <div className="card">
          <Toolbar
            className="mb-3"
            start={leftToolbarTemplate}
            end={rightToolbarTemplate}
          ></Toolbar>

          <DataTable
            ref={dt}
            value={HomeClients}
            selection={selectedHomeClients}
            onSelectionChange={(e) => setSelectedHomeClients(e.value)}
            dataKey="id"
            paginator
            rows={10}
            rowsPerPageOptions={[5, 10, 25]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Product Icons"
            globalFilter={globalFilter}
            header={header}
          >
            <Column selectionMode="multiple" exportable={false}></Column>
            <Column
              field="id"
              header="Code"
              sortable
              width="150px"
              style={{ textAlign: "center" }}
            ></Column>
            <Column
              field="imageUrl"
              header="Image"
              body={imageBodyTemplate}
            ></Column>
            <Column
              field="sortOrder"
              header="Order"
              sortable
              style={{ textAlign: "center" }}
            ></Column>

            <Column
              body={actionBodyTemplate}
              exportable={false}
              style={{ minWidth: "12rem" }}
            ></Column>
          </DataTable>
        </div>

        <Dialog
          visible={HomeClientsDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="HomeClient Details"
          modal
          className="p-fluid"
          footer={productDialogFooter}
          onHide={hideDialog}
        >
          {HomeClient.imageUrl && (
            <div className="image-container">
              <img
                loading="lazy"
                src={
                  process.env.REACT_APP_BACKEND_URL_IMAGES + HomeClient.imageUrl
                }
                alt={HomeClient.imageUrl}
                className="product-image block m-auto pb-3"
              />
            </div>
          )}
          <div className="field">
            <label htmlFor="name" className="font-bold mb-1">
              Name :
            </label>
            <InputText
              id="name"
              value={HomeClient.alt ?? ""}
              onChange={(e) => onInputChange(e, "alt")}
              required
              autoFocus
              className={classNames({
                "p-invalid": submitted && !HomeClient.alt,
              })}
            />
            {submitted && !HomeClient.alt && (
              <small className="p-error">Name is required.</small>
            )}
          </div>
          <div className="field">
            <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
              Order :
            </label>
            <InputText
              id="sortOrder"
              type="number"
              value={HomeClient.sortOrder ?? 1}
              onChange={(e) => onInputChange(e, "sortOrder")}
              required
              className={classNames({
                "p-invalid": submitted && !HomeClient.sortOrder,
              })}
            />
          </div>
          <div className="field">
            <label htmlFor="image" className="mt-3 mb-1 font-bold">
              Image :
            </label>
            <FileUpload
              name="image"
              mode="basic"
              accept="image/*"
              onSelect={onFileUpload}
            />
          </div>
        </Dialog>

        <Dialog
          visible={DeleteHomeClient}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Confirm"
          modal
          footer={deleteProductDialogFooter}
          onHide={hideDeleteProductDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{
                textAlign: "center",
                fontSize: "2rem",
                width: "100%",
                color: "#6659ff",
              }}
            />
            <div>
              <p style={{ textAlign: "center", marginBottom: "5px" }}>
                Are you sure you want to delete:
              </p>
              {HomeClient && (
                <p style={{ textAlign: "center", marginBottom: "0" }}>
                  <b>{HomeClient.title}</b>
                </p>
              )}
            </div>
          </div>
        </Dialog>

        <Dialog
          visible={DeleteHomeClientsDialog}
          style={{ width: "32rem" }}
          breakpoints={{ "960px": "75vw", "641px": "90vw" }}
          header="Confirm"
          modal
          footer={deleteProductsDialogFooter}
          onHide={hideDeleteProductsDialog}
        >
          <div className="confirmation-content">
            <i
              className="pi pi-exclamation-triangle mr-3"
              style={{
                textAlign: "center",
                fontSize: "2rem",
                width: "100%",
                color: "#6659ff",
              }}
            />
            {HomeClient && (
              <p
                style={{
                  textAlign: "center",
                  marginTop: "10px",
                  marginBottom: "25px",
                }}
              >
                Are you sure you want to delete the selected Clients?
              </p>
            )}
          </div>
        </Dialog>
      </div>
    </div>
  );
}

export default HomeClients;
